import React from 'react';
import { Scale, AlertTriangle, Shield, Target } from 'lucide-react';
import CTASection from '../../components/CTASection';

const CopyrightEnforcementPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Copyright <span className="text-[#FF6B35]">Enforcement</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Stop unauthorized use of your copyrighted works. We pursue infringers aggressively to protect your creative rights and recover damages.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>Copyright infringement is rampant online and offline. From plagiarized content and unauthorized reproductions to illegal downloads and counterfeit products, infringers profit from your creative work without permission or payment.</p>
            <p>Our enforcement services include sending cease and desist letters, filing DMCA takedown notices, negotiating settlements, and litigating in federal court when necessary. We recover damages, stop ongoing infringement, and deter future violations.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <AlertTriangle className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Cease & Desist</h3>
              <p className="text-gray-700 text-sm">Formal legal demands to stop infringement</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">DMCA Takedowns</h3>
              <p className="text-gray-700 text-sm">Remove infringing content from websites and platforms</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Target className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Settlement Negotiation</h3>
              <p className="text-gray-700 text-sm">Recover damages without costly litigation</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Scale className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Federal Litigation</h3>
              <p className="text-gray-700 text-sm">Sue for statutory damages up to $150,000 per work</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default CopyrightEnforcementPage;